<template>
  <div>
    <b-modal
      ref="cancel-po-modal"
      hide-footer
      :title="title"
      id="modal-prevent-closing"
    >
      <b-form-group class="required-control col-md-6 pl-0">
        <label>Loại trả phiếu:</label>
        <b-form-select
          class="select-style"
          v-model="selectedCancelType"
          :options="listCancelType"
          size="sm"
          value-field="id"
          text-field="name"
        >
        </b-form-select>
      </b-form-group>
      <b-form-group class="required-control col-md-6 pl-0">
        <label>Lý do hủy:</label>
        <b-form-select
          class="select-style"
          v-model="selectedCancelReason"
          :options="listCancelReason"
          size="sm"
          value-field="id"
          text-field="name"
        >
        </b-form-select>
      </b-form-group>
      <b-form-group class="required-control">
        <label>Mô tả lý do hủy:</label>
        <b-form-textarea
          size="sm"
          v-model="$v.form.cancelReason.$model"
          :placeholder="'Thêm mô tả lý do hủy...'"
          :rows="6"
          :max-rows="6"
          :state="validateState('cancelReason')"
        ></b-form-textarea>
        <b-form-invalid-feedback id="input-live-feedback"
          >Vui lòng nhập lý do hủy</b-form-invalid-feedback
        >
      </b-form-group>
      <b-button
        style="fontweight: 600; width: 70px"
        variant="primary"
        size="sm"
        @click="onSubmit"
        >Lưu</b-button
      >
      <b-button
        style="margin-left: 10px; font-weight: 600; width: 70px"
        variant="secondary"
        size="sm"
        @click="hideModal"
        >Hủy</b-button
      >
    </b-modal>
  </div>
</template>

<script>
import { required } from 'vuelidate/lib/validators';
import { validationMixin } from 'vuelidate';
import PurchaseOrderService from '@/core/api/purchase-order/purchase-order.service';
import { API_RESPONSE_STATUS, PURCHASE_ORDER_STATUS } from '@/utils/enum';
import { makeToastSuccess, makeToastFaile } from './../../../utils/common';

// P6: khớp enum BE PO_CANCEL_TYPE (1=PURCHASE, 2=ACCOUNTANT)
const CANCEL_TYPE = {
  PURCHASE: 1,
  ACCOUNTANT: 2,
};

export default {
  props: ['purchaseOrderCode', 'purchaseOrderId', 'purchaseOrderStatus'],
  mixins: [validationMixin],
  data() {
    return {
      title: '',
      form: {
        cancelReason: '',
      },
      selectedCancelType: CANCEL_TYPE.PURCHASE,
      listCancelType: [
        { id: CANCEL_TYPE.PURCHASE, name: 'Trả phiếu duyệt' },
        { id: CANCEL_TYPE.ACCOUNTANT, name: 'Trả phiếu xác nhận' },
      ],
      selectedCancelReason: 1,
      listCancelReason: [
        { id: 1, name: 'Thông tin' },
        { id: 2, name: 'Tồn kho' },
        { id: 3, name: 'Sức bán' },
        { id: 4, name: 'Ngân sách' },
      ],
    };
  },
  validations: {
    form: {
      cancelReason: { required },
    },
  },
  methods: {
    validateState(name) {
      const { $dirty, $error } = this.$v.form[name];
      return $dirty ? !$error : null;
    },
    showModal: function () {
      this.title = `Trả phiếu yêu cầu nhập hàng ${this.purchaseOrderCode}`;
      // P6: auto-default theo status PO. PURCHASED → KT trả; READY/NEW → Trưởng NH trả.
      if (this.purchaseOrderStatus === PURCHASE_ORDER_STATUS.PURCHASED) {
        this.selectedCancelType = CANCEL_TYPE.ACCOUNTANT;
      } else {
        this.selectedCancelType = CANCEL_TYPE.PURCHASE;
      }
      this.$refs['cancel-po-modal'].show();
    },
    hideModal: function () {
      this.$refs['cancel-po-modal'].hide();
    },
    async onSubmit() {
      this.$v.form.$touch();
      if (this.$v.form.$anyError) {
        return;
      }

      const payload = {
        // Ép Number để BE @IsEnum strict không reject (b-form-select đôi khi
        // trả string khi options dùng value-field id).
        cancelReasonType: Number(this.selectedCancelType),
        cancelReasonId: Number(this.selectedCancelReason),
        note: this.form.cancelReason,
      };

      try {
        const { data } = await PurchaseOrderService.cancel(
          this.purchaseOrderId,
          payload,
        );
        if (data.status === API_RESPONSE_STATUS.SUCCESS) {
          makeToastSuccess(data.message);
          this.hideModal();
          this.$emit('onSuccess', true);
        } else {
          makeToastFaile(data.message);
        }
      } catch (err) {
        const msg = err.response?.data?.message || err.message;
        makeToastFaile(msg);
      }
    },
  },
};
</script>
